export interface ServiceOrderExtra {
  isExtra: any;
  id: string;
  type: string;
  name: string;
  number: string;
  reference?: string;
  quantity: number;
  price: number;
  costPrice: number;
  margin: number;
  serviceOrderId: string;
  discount: number;
  vat: number;
  total: number;
  inventoryId?: string;
  availableStock?: number;
}

export interface CreateServiceOrderExtra {
  type: string;
  name: string;
  number?: string;
  reference?: string;
  quantity: number;
  price: number;
  costPrice: number;
  margin: number;
  serviceOrderId?: string;
  discount: number;
  vat: number;
  inventoryId?: string;
}

export interface CreateServiceOrderDocument {
  name: string;
  type: string;
  content: string;
  contentType: string;
  serviceOrderId: string;
}

export interface DeleteExtra {
  id: string;
  serviceOrderId: string;
}

export const InitialServiceOrderExtra = {
  id: '',
  name: '',
  type: '',
  number: undefined,
  description: undefined,
  quantity: undefined,
  price: undefined,
  costPrice: undefined,
  margin: undefined,
  serviceOrderId: '',
  vat: undefined,
  discount: undefined,
};
